export default __webpack_public_path__ + "static/media/LetYourSoulSing.c8eee49c.mp3";